import { useEffect, useState } from "react";
import CustomInputSeparate from "../../all-patient/components/CuInputSeprate";
import "../css/ConsultationVitals.css";
// import { Popup } from "semantic-ui-react";
import VitalView from "../component/VitalView";
import { FaArrowRightLong, FaArrowTrendUp } from "react-icons/fa6";
import CuInput from "../../all-patient/components/CuInput";
import BpReadings from "../component/BpReading";
import Popup from "../../common_component/component/Popup";
export const CustomDropdown = ({
  options,
  value,
  onChange,
  type = "desktop",
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const selectOption = (selectedOption) => {
    onChange(selectedOption);
    setIsOpen(false);
  };

  // Set default value to the first item in options array
  useEffect(() => {
    if (!value && options.length > 0) {
      onChange(options[0].value);
    }
  }, [options, value]);

  return (
    <div className="relative h-full" style={{ flexBasis: "30%" }}>
      <div
        className={`cu-consultation-vital-unit cursor-pointer`}
        onClick={toggleDropdown}
      >
        {value}
      </div>
      {isOpen && (
        <div className="absolute z-10 w-fit bg-white border border-gray-300 rounded shadow-lg">
          {options.map((option, index) => (
            <div
              key={option.value}
              className={`cu-consultation-vital-label cursor-pointer py-2 px-4 hover:bg-gray-100 ${
                value === option.text ? "bg-gray-100" : ""
              }`}
              onClick={() => selectOption(option.value)}
            >
              {option.text}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const ConsultationVitals = ({
  vitals,
  setVitals,
  previousVisits,
  handleSaveConsultation,
  readingLoading,
}) => {
  const getUnitOptions = (units) => {
    return units.split(",").map((unit) => ({ value: unit, text: unit }));
  };

  const unitChangeHandler = (selectedUnit, vitalId) => {
    setVitals((prev) => {
      return prev.map((vital) =>
        vital.id === vitalId ? { ...vital, selected_unit: selectedUnit } : vital
      );
    });
  };

  const onVitalChange = (value, id) => {
    setVitals((prev) =>
      prev.map((vital) =>
        vital.id === id
          ? {
              ...vital,
              value1: value.split("/")[0],
              value2: value.split("/")[1],
            }
          : vital
      )
    );
  };

  const calculateBMI = () => {
    const heightObj = vitals?.find(
      (ele) => ele?.type?.label?.toLowerCase() === "height"
    );
    const weightObj = vitals?.find(
      (ele) => ele?.type?.label?.toLowerCase() === "weight"
    );
    if (Number(weightObj?.value1) > 0 && Number(heightObj?.value1) > 0) {
      const unit = heightObj?.selected_unit?.toLowerCase();
      let height = Number(heightObj?.value1);
      let weight = Number(weightObj?.value1);

      if (unit === "cm") {
        height = height / 100; // Convert height from cm to meters
      } else if (unit === "inch") {
        height = height * 0.0254; // Convert height from inches to meters
      }
      // Calculate BMI
      const bmi = weight / (height * height);
      return bmi.toFixed(2); // Round BMI to two decimal places
    }
    return 0;
  };

  const isBMIVisible = () => {
    if (vitals?.length > 0) {
      const requiredForBMI = [];
      for (let i of vitals) {
        if (
          i?.type?.label?.toLowerCase() === "height" ||
          i?.type?.label?.toLowerCase() === "weight"
        ) {
          requiredForBMI.push(i);
        }
      }
      if (requiredForBMI?.length === 2) {
        return true;
      } else {
        return false;
      }
    }
  };

  return (
    <div className="cu-consultation-vitals-container">
      <div className="cu-consultation-vitals-label-cont">
        <label className="cu-consultation-vitals-label">Vitals</label>
      </div>
      <div className="cu-consultation-vitals">
        {vitals?.map((vital, indx) => (
          <div className="cu-consultation-vital" key={vital?.id}>
            <div className="flex justify-between items-center">
              <label className="cu-consultation-vital-label">
                {vital?.type?.label}
              </label>
              {vital?.type?.label.toLowerCase() !== "spo2" &&
                vital?.type?.label.toLowerCase() !== "height" && (
                  <span className="flex items-center gap-[10px]">
                    {vital?.type?.label.toLowerCase() === "bp" && (
                      <BpReadings
                        bpreadings={vital}
                        setVitals={setVitals}
                        vitalIndx={indx}
                        getUnitOptions={getUnitOptions}
                        handleSaveConsultation={handleSaveConsultation}
                        readingLoading={readingLoading}
                      />
                    )}
                    <Popup
                      trigger={
                        (vital?.type?.label.toLowerCase() === "bp" && (
                          <FaArrowTrendUp
                            size={15}
                            className="cursor-pointer text-red-500"
                          />
                        )) ||
                        (vital?.type?.label.toLowerCase() === "weight" && (
                          <FaArrowTrendUp
                            size={15}
                            className="cursor-pointer text-green-500"
                          />
                        )) ||
                        (vital?.type?.label.toLowerCase() === "pulse" && (
                          <FaArrowRightLong
                            size={15}
                            className="cursor-pointer text-yellow-500"
                          />
                        )) ||
                        (vital?.type?.label.toLowerCase() === "temprature" && (
                          <FaArrowRightLong
                            size={15}
                            className="cursor-pointer text-red-500"
                          />
                        ))
                      }
                      content={
                        <VitalView
                          label={vital?.type?.label}
                          previousVisits={previousVisits}
                        />
                      }
                      position="right"
                    />
                  </span>
                )}
            </div>
            <div className="cu-consultation-vital-input-cont cu-consultation-vital-input">
              <CustomInputSeparate
                separator="/"
                maxLength={3}
                fieldCount={vital?.type?.label.toLowerCase() === "bp" ? 2 : 1}
                initialValues={[
                  vital?.value1 === 0 ? "" : vital?.value1,
                  vital?.value2 === 0 ? "" : vital?.value2,
                ]}
                inputWidth={`40px`}
                // className={`cu-consultation-vital-input`}
                onChange={(value) => onVitalChange(value, vital?.id)}
                unit={vital?.selected_unit}
                label={vital?.type?.label}
              />
              <CustomDropdown
                options={getUnitOptions(vital?.type?.unit)}
                value={vital.selected_unit}
                onChange={(selectedUnit) =>
                  unitChangeHandler(selectedUnit, vital?.id)
                }
              />
            </div>
          </div>
        ))}
        {isBMIVisible() && (
          <div className="">
            <div className="flex justify-between items-center">
              <label className="cu-consultation-vital-label">BMI</label>
            </div>
            <div className="cu-consultation-vital-input-cont w-[80px] border-none">
              <CuInput value={calculateBMI()} disabled={true} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConsultationVitals;
